import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {

  constructor(
    private authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.logOut();
  }

  logOut(): void {
    setTimeout(() => {
      this.authService.logout();
    }, 3500);
  }

}
